import { Link } from "@inertiajs/react"
import { LayoutDashboard } from "lucide-react"
import { useTranslation } from "react-i18next"

import { EmptyState } from "@/components/empty-state"
import { Button } from "@/components/ui/button"
import { newMissionPath } from "@/routes"

/**
 * OKS-38 — Cold-start empty state for the brand dashboard.
 *
 * Shown when the brand has zero active missions, zero active crew, AND
 * has never had a mission (controller-side `cold_start === true` per
 * TRD §K13). KPI strip + deadlines panel are NOT rendered in this branch.
 *
 * The CTA renders as `<Button asChild>` wrapping an Inertia `<Link>` so
 * the click navigates without a full page reload, while the Button's
 * styling carries.
 */
export function DashboardColdStart() {
  const { t } = useTranslation()

  return (
    <div data-testid="dashboard-cold-start">
      <EmptyState
        icon={LayoutDashboard}
        title={t("brand_home.cold_start.title")}
        description={t("brand_home.cold_start.description")}
        actions={
          <Button asChild data-testid="dashboard-cold-start-cta">
            <Link href={newMissionPath()}>
              {t("brand_home.cold_start.cta")}
            </Link>
          </Button>
        }
      />
    </div>
  )
}
